import { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { ETypeOfNotification, Modal } from 'medere-ui-framework';
import { Box } from '../../../../../interface/interface';
import { CashRegisterDTO } from '../../../../../dto/locationcash/LocationCashDTO';
import '../../../../CashRegister/CashRegisterView.scss';

interface Props {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    box: Box | null;
    availableCashRegisters: CashRegisterDTO[];
    currentCashRegister: CashRegisterDTO | null;
    onSaved: (cashRegister: CashRegisterDTO | null) => Promise<void>;
    notify: (notification: any) => void;
}

export default function CashRegisterAssignmentModal({ visible, setVisible, box, availableCashRegisters, currentCashRegister, onSaved, notify }: Props) {
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setSelectedId(currentCashRegister?.locationCashRegisterId ?? null);
    }, [currentCashRegister, visible]);

    const options = [...availableCashRegisters, ...(currentCashRegister ? [currentCashRegister] : [])]
        .filter((item, index, all) => all.findIndex(other => other.locationCashRegisterId === item.locationCashRegisterId) === index);

    async function save() {
        setSaving(true);
        try {
            const selected = options.find(item => item.locationCashRegisterId === selectedId) ?? null;
            await onSaved(selected);
            setVisible(false);
            notify({ title: 'Caja asignada', icon: 'pi-check-circle', typeOfNotification: ETypeOfNotification.INFO });
        } catch (error: any) {
            notify({ title: 'No se pudo asignar la caja', desc: error?.response?.data?.message, icon: 'pi-times', typeOfNotification: ETypeOfNotification.ERROR });
        } finally { setSaving(false); }
    }

    return (
        <Modal
            visible={visible}
            setVisible={setVisible}
            header={<div className="cash-register-modal-title"><span className="cash-register-modal-title-icon" aria-hidden="true"><i className="pi pi-link" /></span><div><span className="cash-register-modal-eyebrow">Puesto de atención</span><h2>Asignar caja</h2></div></div>}
            width="w-medium"
            closable={!saving}
            className="cash-register-modal"
        >
            <div className="cash-register-modal-content">
                <div className="cash-register-modal-context"><span className="cash-register-modal-context-label">Puesto seleccionado</span><strong>{box?.description ?? 'Sin puesto seleccionado'}</strong></div>
                <div className="cash-register-form-section">
                    <div className="cash-register-section-heading"><h3>Caja asociada</h3><p>Una caja solo puede estar asignada a un puesto de atención a la vez.</p></div>
                    <div className="cash-register-form-field cash-register-assignment-field">
                        <label htmlFor="cash-register-assignment">Caja</label>
                        <Dropdown inputId="cash-register-assignment" className="w-full" value={selectedId} options={options} optionLabel="description" optionValue="locationCashRegisterId" placeholder="Sin caja asignada" showClear onChange={e => setSelectedId(e.value ?? null)} />
                        <span className="cash-register-field-hint"><i className="pi pi-info-circle" aria-hidden="true" /> Seleccionar “Sin caja asignada” para liberar el puesto.</span>
                    </div>
                </div>
                <div className="cash-register-modal-actions">
                    <Button label="Cancelar" className="buttonMain3" onClick={() => setVisible(false)} disabled={saving} />
                    <Button label="Guardar asignación" icon="pi pi-check" className="buttonMain" loading={saving} onClick={save} />
                </div>
            </div>
        </Modal>
    );
}
